import { Box } from '@chakra-ui/react';
import Select from '@components/filter/select';
import { ConditionalComponent } from '@components/functionComponent';
import { TextBold } from '@components/typography';
import useUpdateConfigurationInfoState from '@domain/configuration/useUpdateConfigurationInfoState';
import CheckboxComponent from '@pages/storeConfigurationDetail/components/checkbox';
import { useParams } from 'react-router-dom';
import styles from './styles.module.css';

const RESYNC_TYPE_OPTION = [{ id: 'ipos', name: 'IPOS' }];

const PosSync = ({ configuration, isLoadingConfiguration }) => {
    const { id } = useParams();
    const updateConfigurationInfoState = useUpdateConfigurationInfoState(id);
    const selectedResyncType = RESYNC_TYPE_OPTION.find((type) => type.id === configuration?.resync_type);

    return (
        <Box className={styles['pos-sync__container']}>
            <TextBold className={styles['title']}>POS Sync</TextBold>
            <CheckboxComponent
                value={configuration?.is_resync}
                isLoading={isLoadingConfiguration}
                label="Enable Resync"
                description="Aktivasi fitur sinkronisasi ulang untuk Upload Type API"
                onChange={(val) =>
                    updateConfigurationInfoState?.mutate({
                        [val?.id]: val?.value,
                        resync_type: val?.value === true ? RESYNC_TYPE_OPTION[0].id : null,
                        template_upload: { id: 'Custom', name: 'Custom' },
                    })
                }
                id="is_resync"
            />
            <ConditionalComponent statement={configuration?.is_resync}>
                <Select
                    isDisabled={true}
                    data={RESYNC_TYPE_OPTION}
                    isloadingComponent={isLoadingConfiguration}
                    title="POS Type"
                    isMultiple={false}
                    isCanSearch={false}
                    mt="12px"
                    placeholder={selectedResyncType?.name}
                />
            </ConditionalComponent>
        </Box>
    );
};

export default PosSync;
